import axios from 'axios';
import { alertify } from '../app_methods';
import store from '../redux/store';


let current_user = {};
const initAuthentication = () => {
    current_user = store.getState().userReducer.current_user;
};
store.subscribe(initAuthentication);
initAuthentication();

const loadBalancer = (config) => {
    if (process.env.REACT_APP_ENV === 'local') {
        if (config.url.indexOf("tax-payments/") > -1) {
            config.baseURL = process.env.REACT_APP_TAX_PMT_SERVICE_URL;
        } else if (config.url.indexOf("vendor-payouts/") > -1) {
            config.baseURL = process.env.REACT_APP_VENDOR_PO_SERVICE_URL;
        }
    }
}


const axiosIns = axios.create({
    baseURL: process.env.REACT_APP_SERVICE_URL,
    withCredentials: true,
    headers: {}
});

axiosIns.interceptors.request.use(function (config) {
    loadBalancer(config);

    if (config.url != "v1/authentications/merchant/key/") {
        if (config.method.toLowerCase() == "get" || config.method.toLowerCase() == "delete") {
            config.params.key = current_user.key;
        }
        else {
            config.data.key = current_user.key;
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

axiosIns.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response && error.response.status === 503) {
        alertify("Service Unavailable", "WIRE services are unavailable at the moment. Please try again after some time. We appreciate your patience.", "error", { hideFooter: true });
    }
    else if (error.response && error.response.status === 401) {
        let redirect_url = `${process.env.REACT_APP_AUTH_URL}easebuzz/login?next=${encodeURI(process.env.REACT_APP_AUTH_REDIRECT_URL)}`;
        let message = "Seems like you are not logged in. You will be redirected to Easebuzz Login Page in 5 seconds...";
        if (error.response.data instanceof Blob) {
            var reader = new FileReader();
            message = "Seems like you are not logged in. You will be redirected to Wire Login Page in 5 seconds...";
            reader.onload = function () {
                let data = JSON.parse(reader.result);
                redirect_url = data.login_url;
            }
            reader.readAsText(error.response.data);
        }
        else if ((error.response.data || {}).login_url) {
            redirect_url = error.response.data.login_url;
            message = "Seems like you are not logged in. You will be redirected to Wire Login Page in 5 seconds...";
        }
        else if (!(error.response.data || {}).wire_allowed) {
            redirect_url = `${process.env.REACT_APP_EASEBUZZ_URL}merchant/dashboard`;
            message = "Seems like you are not allowed to access this resource. You will be redirected to Easebuzz Dashboard Page in 5 seconds...";
        }
        else if (!(error.response.data || {}).wire_activated) {
            redirect_url = `${process.env.REACT_APP_EASEBUZZ_URL}merchant/dashboard`;
            message = "Seems like your Wire account has been deactivated. You will be redirected to Easebuzz Dashboard Page in 5 seconds...";
        }
        else if (!(error.response.data || {}).easebuzz_allowed) {
            redirect_url = `${process.env.REACT_APP_AUTH_URL}easebuzz/login`;
            message = "Seems like your Easebuzz account needs approval. You will be redirected to Easebuzz Dashboard Page in 5 seconds...";
        }

        alertify("Authentication Failed", message, "warning", { hideFooter: true });
        setTimeout(() => {
            window.location.replace(redirect_url);
        }, 5000);
    }
    return Promise.reject(error);
});

export { axiosIns };
